import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const FtpUserService = {
    list: async (payload = {}) => axios.post(API_KEEPER + "/ftpUsers/list", payload).then(({data}) => data?.data?.data ?? data?.data ?? []).catch((err) => { throw err }),

    get: async (id) => axios.get(API_KEEPER + "/ftpUsers/get/" + id).then(({data}) => data?.data ?? data).catch((err) => { throw err }),

    update: async (form) => axios.post(API_KEEPER + "/ftpUsers/update", form).then(({data}) => data).catch((err) => { throw err }),

    delete: async (id) => axios.delete(API_KEEPER + "/ftpUsers/delete/" + id).catch((err) => { throw err }),
};

export default FtpUserService;
